import AppHttp from '@/lib/AppHttp';
import {
    CreateLevelledResourceCommand, ExportResponse,
    LevelledResourceViewModel,
    ReorderLevelledResourcesCommand,
    UpdateLevelledResourceCommand
} from '@/models/api';

export class LevelledResources {
    private resource: string = 'LevelledResources';


    public async getLevelledResources(departmentId: string): Promise<LevelledResourceViewModel[]> {
        const response = await AppHttp.get(`Departments/${departmentId}/${this.resource}`);
        const data = response ? response.data?.resources : [];
        return data;
    }

    public async updateLevelledResource(departmentId: string, command: UpdateLevelledResourceCommand) {
        const response = await AppHttp.post(`Departments/${departmentId}/${this.resource}/Update`, command);
        const data = response ? response.data : null;
        return data;
    }

    public async createLevelledResource(departmentId: string, command: CreateLevelledResourceCommand) {
        const response = await AppHttp.post(`Departments/${departmentId}/${this.resource}/Create`, command);
        const data = response ? response.data : null;
        return data;
    }

    public async reorderLevelledResources(departmentId: string, command: ReorderLevelledResourcesCommand) {
        const response = await AppHttp.post(`Departments/${departmentId}/${this.resource}/Reorder`, command);
        const data = response ? response.data : null;
        return data;
    }

    public async deleteLevelledResource(departmentId: string, resourceId: string) {
        const response = await AppHttp.delete(`Departments/${departmentId}/${this.resource}/${resourceId}`);
        const data = response ? response.data : null;
        return data;
    }

    public async archiveLevelledResource(departmentId: string, id: string) {
        const response = await AppHttp.put(`Departments/${departmentId}/${this.resource}/${id}/Archive`, null);
        const data = response ? response.data : null;
        return data;
    }

    public async restoreLevelledResourceFromArchive(departmentId: string, id: string) {
        const response = await AppHttp.put(`Departments/${departmentId}/${this.resource}/${id}/Restore`, null);
        const data = response ? response.data : null;
        return data;
    }

    public async exportLevelledResources(departmentId: string): Promise<ExportResponse> {
        const response = await AppHttp.get(`Departments/${departmentId}/${this.resource}/export`);
        const data = response ? response.data : null;
        return data;
    }

    public async importLevelledResources(departmentId: string, file: any) {
        const response = await AppHttp.postWithFiles(`Departments/${departmentId}/${this.resource}/import`, {}, [file]);
        const data = response ? response.data : null;
        return data;
    }
}

export default new LevelledResources();